<script lang="ts">
	import { AvatarColorVariant } from '@Shelly/shelly-design-system/helpers/enums';
	import { CircleAvatar } from '@Shelly/shelly-design-system/index';

	export let index = 0; // index of the math parameter
	export let name: string;

	//Colors to be used for color coding of the math parameters. Shuffle a bit as too similar colors are not good for the eye.
	const LIST_COLORS = [
		'COLOR_GREEN',
		'COLOR_PEACH',
		'COLOR_LIGHTBLUE',
		'COLOR_WARNING',
		'COLOR_PURPLE',
		'COLOR_CYAN',
		'COLOR_PINK',
		'COLOR_DARKBLUE',
		'COLOR_SECONDARY',
		'COLOR_DANGER',
	];
	let colorVariantStr = LIST_COLORS[index % LIST_COLORS.length];
	let colorVariant = AvatarColorVariant[colorVariantStr];
</script>

<div class="d-flex gap-s align-items-center">
	<CircleAvatar size="m" avatar={name} backgroundColor={colorVariant} text={String(name)} />
	<div class="content text-nowrap pt-s pb-s width-full">
		<slot />
	</div>
</div>
